export const WHATSAPP_NUMBER = "33660705559";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const PHONE_PLACEHOLDER = "+33 6 60 70 55 59";
export const CITY_PLACEHOLDER = "Paris ( Basé a Rosny sous bois )";
export const GARAGE_PHONE = "+33661360510";
export const GARAGE_PHONE_LABEL = "+33 6 61 36 05 10";
